import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pdf-findbar-message-container',
  templateUrl: './pdf-findbar-message-container.component.html',
  styleUrls: ['./pdf-findbar-message-container.component.css']
})
export class PdfFindbarMessageContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
